import { configureStore } from '@reduxjs/toolkit'
import languageReducer from './features/counter/counterSlice'

export default configureStore({
  reducer: {
    language: languageReducer,
  },
})
